<template>
  <el-dialog
    :visible="showDialog"
    :width="configs.width"
    :style="configs.style"
    :show-close="configs.showClose"
    :lock-scroll="configs.lockScroll"
    :custom-class="configs.class"
    :center="configs.center"
    append-to-body
    :close-on-click-modal="false"
    @open="openDialog"
    @close="closeDialog"
  >
    <template slot="title">
      <slot name="customHeader">
        <span class="el-dialog__title">{{ title }}</span>
      </slot>
    </template>
    <slot />
    <div v-if="configs.showFooter" slot="footer" class="footer">
      <slot name="customFooter">
        <el-button @click="closeDialog">{{ configs.cancelText }}</el-button>
        <el-button type="primary" :loading="confirmLoading" :disabled="confirmDisable" @click="confirmDialog">{{ configs.confirmText }}</el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'GjwDialog',
  props: {
    title: String,
    showDialog: {
      type: Boolean,
      required: true
    },
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    confirmDisable: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    configs() {
      const defaultConfig = {
        class: '',
        style: '',
        width: '640px',
        showClose: true,
        showFooter: true,
        lockScroll: true,
        center: false,
        confirmText: '确定',
        cancelText: '取消',
      }
      return { ...defaultConfig, ...this.config }
    }
  },
  methods: {
    openDialog() {
      this.$emit('open')
    },
    closeDialog() {
      this.$emit('close')
    },
    confirmDialog() {
      this.$emit('confirm')
    },
  }
}
</script>

<style scoped>
::v-deep .el-dialog__body {
  max-height: 500px;
  overflow: auto;
}
</style>
